export default function LaserCutting() {
  const materials = [
    { icon: 'ri-tree-line', name: '나무' },
    { icon: 'ri-file-paper-line', name: '종이' },
    { icon: 'ri-box-3-line', name: '아크릴' },
    { icon: 'ri-shirt-line', name: '가죽' },
    { icon: 'ri-shapes-line', name: '플라스틱' },
    { icon: 'ri-layout-grid-line', name: 'MDF' }
  ];

  const applications = [
    '청첩장', '팝업카드', '디자인명함', '교재',
    '가죽악세사리', 'OHP필름', '스티커', '펠트',
    '직물라벨', '맞춤토퍼', '인테리어소품', 'LED 무드등', '가죽벨트'
  ];

  return (
    <section className="py-20 px-4 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-slate-900 text-amber-500 rounded-full mb-6">
            <i className="ri-scissors-cut-line text-3xl"></i>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            레이저 커팅
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            다양한 재료를 정밀하게 커팅하여 원하는 디자인을 완벽하게 구현합니다
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 mb-16">
          <div className="bg-gradient-to-br from-slate-50 to-gray-50 rounded-2xl p-8 shadow-lg">
            <h3 className="text-2xl font-bold text-slate-900 mb-6 flex items-center gap-3">
              <i className="ri-stack-line text-amber-500"></i>
              커팅 가능 재료
            </h3>
            <div className="grid grid-cols-3 gap-4">
              {materials.map((material, index) => (
                <div
                  key={index}
                  className="flex flex-col items-center gap-2 p-4 bg-white rounded-lg hover:shadow-md transition-shadow cursor-pointer"
                >
                  <div className="w-12 h-12 flex items-center justify-center bg-slate-900 text-amber-500 rounded-full">
                    <i className={`${material.icon} text-2xl`}></i>
                  </div>
                  <span className="text-sm font-semibold text-slate-900">{material.name}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-gradient-to-br from-slate-50 to-gray-50 rounded-2xl p-8 shadow-lg">
            <h3 className="text-2xl font-bold text-slate-900 mb-6 flex items-center gap-3">
              <i className="ri-lightbulb-line text-amber-500"></i>
              활용 분야
            </h3>
            <div className="flex flex-wrap gap-3">
              {applications.map((app, index) => (
                <span
                  key={index}
                  className="px-4 py-2 bg-white text-slate-900 text-sm font-medium rounded-full shadow-sm hover:shadow-md transition-shadow cursor-pointer"
                >
                  {app}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-r from-slate-900 to-slate-800 rounded-2xl p-8 md:p-12 text-white text-center shadow-xl">
          <div className="w-16 h-16 flex items-center justify-center bg-amber-500 text-slate-900 rounded-full mx-auto mb-6">
            <i className="ri-flashlight-line text-3xl"></i>
          </div>
          <p className="text-lg md:text-xl leading-relaxed max-w-4xl mx-auto">
            레이저 가공은 재료에 직접 빛을 쏘아 작업하여 <strong className="text-amber-500">작업시간이 절약</strong>되며,<br />
            <strong className="text-amber-500">대량작업부터 소량 디자인 샘플, 개인 맞춤 제품</strong>까지 제작 가능합니다.
          </p>
        </div>
      </div>
    </section>
  );
}
